module.exports = __webpack_public_path__ + "img/6.649a60b6.png";